module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_8011.c98b6def.png";